<app-header></app-header>
<app-sidebar></app-sidebar>
<main class="text-theme-white px-4 pt-4 pb-28">
  <router-outlet />
</main>
<app-menu></app-menu>
